import { TaskEditFormEntity } from 'domains/index';

export const DEFAULT_FORM: TaskEditFormEntity = {
  name: '',
  info: '',
  isImportant: false,
  isCompleted: false,
};
